import { ContainerComponent, NodeComponent } from './view/node.component';
import { DashboardNodeDirective } from './view/dashboard-node.directive';
import { DroppableDirective } from './view/droppable.directive';
import { DashboardComponent } from './dashboard.component';
import { ViewComponent } from './view/view.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    DashboardComponent,
    ContainerComponent,
    NodeComponent,
    ViewComponent,
    DroppableDirective,
    DashboardNodeDirective,
  ],
  imports: [CommonModule],
  exports: [DashboardComponent, DashboardNodeDirective],
})
export class DashboardModule {}
